import '@chenfengyuan/datepicker/src'
import '@chenfengyuan/datepicker/src/index.scss'

import { getLastStartDate } from 'utils/pivot/date/getLastStartDate'
import { createAutoCorrectedDatePipe } from 'text-mask-addons'
import baseControllerInput from './baseControllerInput'
import getErrorStartDate from './validations/startDate'
import { DATE_REGEX } from 'core/constants/regex'
import { alterDate, stringToDate } from '@hc-frontend/utils'
import parseSetValue from './setStartDate'
import store from 'utils/store/withMiddleware'

export default ({ input, handleUpdateDate, ...params }) => {
  const controller = baseControllerInput({
    getErrorMessage: state => {
      return getErrorStartDate(state.input.value)
    },
    parseSetValue,
    maskConfig: {
      mask: DATE_REGEX,
      pipe: createAutoCorrectedDatePipe('mm/dd/yyyy'),
      keepCharPositions: true
    }
  })({ input, ...params })

  const field = $(input)
  const mainState = store.getState()
  const startDate = mainState.nextStartDate
    ? stringToDate(mainState.nextStartDate)
    : alterDate({ days: 1 })

  if (handleUpdateDate) {
    field.on('change', () => {
      handleUpdateDate({ sDate: controller.getStatus().value })
    })
  }

  field.datepicker({
    trigger: `#wrap-${input.name} .hc-icon-calendar`,
    autoHide: true,
    startDate,
    endDate: alterDate({
      date: startDate,
      days: getLastStartDate() - 1
    }),
    show: () => {
      const status = controller.getStatus()

      if (status.valid) {
        field.datepicker('update')
      } else {
        controller.reset()
        field.datepicker('reset')
      }
    },
    hide: () => {
      setTimeout(controller.validate, 0)
    }
  })

  controller.updateNextStartDate = function updateNextStartDate(sdate) {
    controller.setValue(sdate)
    sdate = stringToDate(sdate)
    field.datepicker('setStartDate', sdate)
    field.datepicker(
      'setEndDate',
      alterDate({
        date: sdate,
        days: getLastStartDate() - 1
      })
    )
  }

  return controller
}
